const BANKS = [
  { match: ["bca", "central asia"], color: "#0B3A8C", label: "BCA" },
  { match: ["bni", "negara indonesia"], color: "#F26522", label: "BNI" },
  { match: ["bri", "rakyat indonesia"], color: "#00529C", label: "BRI" },
  { match: ["mandiri"], color: "#E8A800", label: "Mandiri" },
  { match: ["seabank", "sea bank"], color: "#EE4D2D", label: "SeaBank" },
  { match: ["ocbc", "nisp"], color: "#D0202E", label: "OCBC" },
  { match: ["btn"], color: "#F58220", label: "BTN" },
  { match: ["permata"], color: "#00A19C", label: "Permata" },
  { match: ["cimb", "niaga"], color: "#7A0C2E", label: "CIMB Niaga" },
  { match: ["danamon"], color: "#005A9C", label: "Danamon" },
  { match: ["bsi", "syariah"], color: "#00A85A", label: "BSI" },
  { match: ["jago"], color: "#F5A623", label: "Jago" },
  { match: ["blu", "bcadigital"], color: "#00B2E3", label: "blu" },
  { match: ["jenius", "btpn"], color: "#0A66FF", label: "Jenius" },
  { match: ["gopay"], color: "#00AED6", label: "GoPay" },
  { match: ["dana"], color: "#118EEA", label: "DANA" },
  { match: ["ovo"], color: "#4C3494", label: "OVO" },
  { match: ["bpd", "bali"], color: "#C8102E", label: "BPD Bali" },
];

export function bankColor(bank) {
  const s = (bank || "").toLowerCase();
  const hit = BANKS.find((b) => b.match.some((m) => s.includes(m)));
  return hit ? hit.color : "#6E6E73";
}

export function rekParts(no) {
  const s = (no || "").toString();
  if (s.length <= 4) return { head: "", tail: s };
  return { head: s.slice(0, -4), tail: s.slice(-4) };
}

export function waLink(noHp, message) {
  const digits = (noHp || "").replace(/\D/g, "");
  if (!digits) return null;
  const intl = digits.startsWith("62")
    ? digits
    : digits.startsWith("0")
      ? `62${digits.slice(1)}`
      : `62${digits}`;
  return `https://wa.me/${intl}?text=${encodeURIComponent(message)}`;
}
